import AppPath from "../../../components/App/models/AppPath";

class EUFinancePath extends AppPath {
  public static readonly EUFinance = new AppPath({
    id: "eu-finance",
    label: "EU Finance",
    path: "/eufinance",
  });

  public static readonly EUFinanceCaseAttachmentDownloader = new AppPath({
    id: "eu-finance-case-attachment-downloader",
    path: "/eufinance/file-download",
  });

  public static readonly EUFinanceCaseAttachmentUploader = new AppPath({
    id: "eu-finance-case-attachment-uploader",
    path: "/eufinance/file-upload",
  });

  public static readonly EUFinanceCaseAttachmentViewer = new AppPath({
    id: "eu-finance-case-attachment-viewer",
    path: "/eufinance/file-viewer",
  });
}

export default EUFinancePath;
